import { useEffect, useState } from "react";
import { Checkbox, Input, Modal, Segmented, Select } from "antd";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import styles from "./SingleCardDetails.module.css";

const { Option } = Select;

const CashMethod = ({
  cashOpen,
  setCashOpen,
  handleOk,
  handleCancel,
  cashValue,
  setCashValue,
  totalNetAmt,
  cardAmt,
  setCardAmt,
  upiAmt,
  setUpiAmt,
  onlineAmt,
  setOnlineAmt,
  cashAmt,
  setCashAmt,
  creditAmt,
  setCreditAmt,
  setSwitchCredit,
  switchCredit,
  creditCashValue,
  setCreditCashValue,
  creditCashAmt,
  setCreditCashAmt,
  creditCardAmt,
  setCreditCardAmt,
  creditUpiAmt,
  setCreditUpiAmt,
  creditOnlineAmt,
  setCreditOnlineAmt,
}) => {
  const [selectionLocked, setSelectionLocked] = useState(false);
  const [selectionCreditLocked, setSelectionCreditLocked] = useState(false);

  const handleChange = (method) => {
    if (!selectionLocked) {
      setCashValue(method);
      setOnlineAmt(0);
      setUpiAmt(0);
      setCardAmt(0);
      setCashAmt(0);
      setCreditAmt(0);
    }
    if (method === "CARD") {
      setCardAmt(totalNetAmt);
    }
    if (method === "UPI") {
      setUpiAmt(totalNetAmt);
    }
    if (method === "ONLINE") {
      setOnlineAmt(totalNetAmt);
    }
    if (method === "CREDIT") {
      setCreditAmt(totalNetAmt);
    }
    if (method === "CASH") {
      setCashAmt(totalNetAmt);
    }
  };

  const handleCreditChange = (method) => {
    if (!selectionCreditLocked) {
      setCreditCashValue(method);
      setCreditOnlineAmt(0);
      setCreditUpiAmt(0);
      setCreditCardAmt(0);
      setCreditCashAmt(0);
    }
    if (method === "CARD") {
      setCreditCardAmt(totalNetAmt);
    }
    if (method === "UPI") {
      setCreditUpiAmt(totalNetAmt);
    }
    if (method === "ONLINE") {
      setCreditOnlineAmt(totalNetAmt);
    }
    if (method === "CASH") {
      setCreditCashAmt(totalNetAmt);
    }
  };

  const handleModalOk = () => {
    setSelectionLocked(true);
    handleOk(); // call your parent handler if needed
  };

  const handleModalCancel = () => {
    setSelectionLocked(false);
    handleCancel(); // call your parent handler if needed
  };

  const handleCreditModalOk = () => {
    setSelectionCreditLocked(true);
    handleOk(); // call your parent handler if needed
  };
  const handleCreditModalCancel = () => {
    setSelectionCreditLocked(false);
    handleCancel(); // call your parent handler if needed
  };

  useEffect(() => {
    const amount = totalNetAmt - cardAmt - upiAmt - onlineAmt - creditAmt;
    setCashAmt(amount);
  }, [totalNetAmt, cardAmt, upiAmt, onlineAmt, creditAmt]);

  return (
    <Modal
      title={
        <strong
          style={{
            height: "32px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "16px",
            fontWeight: "bold",
            background: "#133975",
            borderRadius: "8px",
            padding: "4px 8px",
            color: "white",
          }}
        >
          Payment Mode
        </strong>
      }
      open={cashOpen}
      onOk={handleModalCancel || handleCreditModalCancel}
      onCancel={handleModalCancel || handleCreditModalCancel}
      closable={false}
      okText="OK"
      cancelText="Cancel"
      maskStyle={{
        backdropFilter: "blur(8px)", // <- this applies the blur effect
        backgroundColor: "rgba(0, 0, 0, 0.2)", // optional: tint the background a little
      }}
    >
      <div>
        {/* <Segmented
          block
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "14px",
            fontWeight: "bold",
            backgroundColor: switchCredit === "Cash" ? "orange" : "orange",
            color: switchCredit === "Cash" ? "black" : "black",
          }}
          value={switchCredit}
          onChange={(value) =>{ 
            setSwitchCredit(value)
            setCardAmt(0);
            setCashAmt(0);
            setUpiAmt(0);
            setOnlineAmt(0);
            setCreditCardAmt(0);
            setCreditCashAmt(0);
            setCreditUpiAmt(0);
            setCreditOnlineAmt(0);
            setCreditCashValue("CREDIT");
            setCashValue("CASH");
          }}
          options={[
            {
              label: <span>Cash / Online</span>,
              value: "Cash",
            },
            {
              label: <span>Credit</span>,
              value: "Credit",
            },
          ]}
        /> */}
        {switchCredit === "Cash" && (
          <div className={styles.cardContainer2}>
            <div className={styles.infoBox2}>
              <div
                className={styles.rowTag2}
                onClick={() => handleChange("CASH")}
              >
                <span className={styles.label2}>
                  <Checkbox
                    checked={cashValue === "CASH"}
                    disabled={selectionLocked}
                    onChange={() => handleChange("CASH")}
                  >
                    {" "}
                    CASH{" "}
                    <CurrencyRupeeIcon
                      style={{ fontSize: "15px", color: "black" }}
                    />
                  </Checkbox>
                </span>
                {/* <span className={styles.separator2}><CurrencyRupeeIcon  style={{fontSize:"30px", color:"black"}}/></span> */}
                <span
                  className={styles.value2}
                  onClick={() => handleChange("CASH")}
                >
                  <Input
                    placeholder="Enter Cash Amount"
                    style={{
                      width: "120px",
                      height: 32,
                      fontSize: "16px",
                      fontWeight: "bold",
                      textAlign: "right",
                    }}
                    disabled
                    value={
                      cashAmt
                        ? cashAmt
                        : totalNetAmt - cardAmt - upiAmt - onlineAmt - creditAmt
                    }
                  />
                </span>
              </div>
              <hr className={styles.fullWidthLine2} />
              <div
                className={styles.rowTag2}
                onClick={() => handleChange("CARD")}
              >
                <span className={styles.label2}>
                  <Checkbox
                    checked={cashValue === "CARD"}
                    disabled={selectionLocked}
                    onChange={() => handleChange("CARD")}
                  >
                    {" "}
                    CARD
                  </Checkbox>
                  <CreditCardIcon style={{ fontSize: "15px", color: "red" }} />
                </span>
                {/* <span className={styles.separator2}><CreditCardIcon  style={{fontSize:"30px", color:"red"}}/></span> */}
                <span
                  className={styles.value2}
                  onClick={() => handleChange("CARD")}
                >
                  <Input
                    placeholder="Enter Card Amount"
                    style={{
                      width: "120px",
                      height: 32,
                      fontSize: "16px",
                      fontWeight: "bold",
                      textAlign: "right",
                    }}
                    value={cardAmt}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 10) {
                        setCardAmt(value);
                        setOnlineAmt(0);
                        setUpiAmt(0);
                        setCreditAmt(0);
                      }
                    }}
                  />
                </span>
              </div>
              <hr className={styles.fullWidthLine2} />
              <div
                className={styles.rowTag2}
                onClick={() => handleChange("UPI")}
              >
                <span className={styles.label2}>
                  <Checkbox
                    checked={cashValue === "UPI"}
                    disabled={selectionLocked}
                    onChange={() => handleChange("UPI")}
                  >
                    {" "}
                    UPI
                  </Checkbox>
                  <DocumentScannerIcon
                    style={{ fontSize: "15px", color: "blue" }}
                  />
                </span>
                {/* <span className={styles.separator2}><DocumentScannerIcon  style={{fontSize:"30px", color:"blue"}}/></span> */}
                <span
                  className={styles.value2}
                  onClick={() => handleChange("UPI")}
                >
                  <Input
                    placeholder="Enter UPI Amount"
                    style={{
                      width: "120px",
                      height: 32,
                      fontSize: "16px",
                      fontWeight: "bold",
                      textAlign: "right",
                    }}
                    value={upiAmt}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 10) {
                        setUpiAmt(value);
                        setCardAmt(0);
                        setOnlineAmt(0);
                        setCreditAmt(0);
                      }
                    }}
                  />
                </span>
              </div>
              <hr className={styles.fullWidthLine2} />
              <div
                className={styles.rowTag2}
                onClick={() => handleChange("ONLINE")}
              >
                <span className={styles.label2}>
                  <Checkbox
                    checked={cashValue === "ONLINE"}
                    disabled={selectionLocked}
                    onChange={() => handleChange("ONLINE")}
                  >
                    {" "}
                    ONLINE
                  </Checkbox>
                  <BookOnlineIcon
                    style={{ fontSize: "15px", color: "green" }}
                  />
                </span>
                {/* <span className={styles.separator2}><BookOnlineIcon  style={{fontSize:"30px", color:"green"}}/></span> */}
                <span
                  className={styles.value2}
                  onClick={() => handleChange("ONLINE")}
                >
                  <Input
                    placeholder="Enter Online Amount"
                    style={{
                      width: "120px",
                      height: 32,
                      fontSize: "16px",
                      fontWeight: "bold",
                      textAlign: "right",
                    }}
                    value={onlineAmt}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 10) {
                        setOnlineAmt(value);
                        setCardAmt(0);
                        setUpiAmt(0);
                        setCreditAmt(0);
                      }
                    }}
                  />
                </span>
              </div>
              <hr className={styles.fullWidthLine2} />
              <div
                className={styles.rowTag2}
                onClick={() => handleChange("CREDIT")}
              >
                <span className={styles.label2}>
                  <Checkbox
                    checked={cashValue === "CREDIT"}
                    disabled={selectionLocked}
                    onChange={() => handleChange("CREDIT")}
                  >
                    {" "}
                    CREDIT
                  </Checkbox>
                  <BookOnlineIcon
                    style={{ fontSize: "15px", color: "green" }}
                  />
                </span>
                {/* <span className={styles.separator2}><BookOnlineIcon  style={{fontSize:"30px", color:"green"}}/></span> */}
                <span
                  className={styles.value2}
                  onClick={() => handleChange("CREDIT")}
                >
                  <Input
                    placeholder="Enter Credit Amount"
                    style={{
                      width: "120px",
                      height: 32,
                      fontSize: "16px",
                      fontWeight: "bold",
                      textAlign: "right",
                    }}
                    value={creditAmt}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 10) {
                        setCreditAmt(value);
                        setCardAmt(0);
                        setUpiAmt(0);
                        setOnlineAmt(0);
                      }
                    }}
                  />
                </span>
              </div>
            </div>
          </div>
        )}
        {switchCredit === "Credit" && (
          <>
            <div className={styles.cardContainer2}>
              <div className={styles.infoBox2}>
                <div
                  className={styles.rowTag2}
                  onClick={() => handleCreditChange("CREDIT")}
                >
                  <span className={styles.label2}>
                    <Checkbox
                      checked={creditCashValue === "CREDIT"}
                      disabled={selectionCreditLocked}
                      onChange={() => handleCreditChange("CREDIT")}
                    >
                      {" "}
                      CREDIT{" "}
                      <CreditScoreIcon
                        style={{ fontSize: "15px", color: "black" }}
                      />
                    </Checkbox>
                  </span>
                  {/* <span className={styles.separator2}><CreditScoreIcon  style={{fontSize:"30px", color:"black"}}/></span> */}
                  <span
                    className={styles.value2}
                    onClick={() => handleCreditChange("CREDIT")}
                  >
                    {totalNetAmt -
                      creditCashAmt -
                      creditCardAmt -
                      creditOnlineAmt -
                      creditUpiAmt}
                  </span>
                </div>
                {/* {creditCashValue === "CREDIT" && (
              <> */}
                <hr className={styles.fullWidthLine2} />
                <div className={styles.rowTag2}>
                  <span className={styles.label2}>Contact No</span>
                  {/* <span className={styles.separator2}>:</span> */}
                  <span className={styles.value2}>
                    <Input
                      placeholder="Enter Customer No"
                      style={{ width: "200px", height: 32, fontSize: "16px" }}
                      // value={customerMobile}
                      // onChange={(e) => {
                      //   const value = e.target.value.replace(/\D/g, "");
                      //   if (value.length <= 10) {
                      //     setCustomerMobile(value);
                      //   }
                      // }}
                    />
                  </span>
                </div>
                <hr className={styles.fullWidthLine2} />
                <div className={styles.rowTag2}>
                  <span className={styles.label2}>Name</span>
                  {/* <span className={styles.separator2}>:</span> */}
                  <span className={styles.value2}>
                    <Select
                      allowClear
                      showSearch={false} // Disable manual typing
                      // placeholder="Select Acc"
                      style={{
                        width: "200px",
                        // border: "2px solid orange",
                        // borderRadius: "7px",
                      }}
                      // className={styles.SelectFilter}
                      // value={selectMetal || undefined}
                      // onChange={(value) => {
                      //   setSelectMetal(value?.value);
                      // }}
                    >
                      {/* {metalData.map((metal, index) => (
              <Option key={index} value={metal.name}>
                {metal.name}
              </Option>
            ))} */}
                    </Select>
                  </span>
                </div>
                <hr className={styles.fullWidthLine2} />
                <div className={styles.rowTag2}>
                  <span className={styles.label2}>Balance Amt</span>
                  {/* <span className={styles.separator2}>:</span> */}
                  <span className={styles.value2}>
                    <Input
                      placeholder="Enter Customer No"
                      style={{ width: "200px", height: 32, fontSize: "16px" }}
                      // value={customerMobile}
                      // onChange={(e) => {
                      //   const value = e.target.value.replace(/\D/g, "");
                      //   if (value.length <= 10) {
                      //     setCustomerMobile(value);
                      //   }
                      // }}
                    />
                  </span>
                </div>
                {/* </>
            )} */}
              </div>
            </div>
            <div className={styles.cardContainer2}>
              <div className={styles.infoBox2}>
                <div
                  className={styles.rowTag2}
                  onClick={() => handleCreditChange("CASH")}
                >
                  <span className={styles.label2}>
                    <Checkbox
                      checked={creditCashValue === "CASH"}
                      disabled={selectionCreditLocked}
                      onChange={() => handleCreditChange("CASH")}
                    >
                      {" "}
                      CASH{" "}
                      <CurrencyRupeeIcon
                        style={{ fontSize: "15px", color: "black" }}
                      />
                    </Checkbox>
                  </span>
                  {/* <span className={styles.separator2}><CurrencyRupeeIcon  style={{fontSize:"30px", color:"black"}}/></span> */}
                  <span
                    className={styles.value2}
                    onClick={() => handleCreditChange("CASH")}
                  >
                    <Input
                      placeholder="Enter Cash Amount"
                      style={{
                        width: "120px",
                        height: 32,
                        fontSize: "16px",
                        fontWeight: "bold",
                        textAlign: "right",
                      }}
                      value={creditCashAmt}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        if (value.length <= 10) {
                          setCreditCashAmt(value);
                          setCreditCardAmt(0);
                          setCreditUpiAmt(0);
                          setCreditOnlineAmt(0);
                        }
                      }}
                    />
                  </span>
                </div>
                <hr className={styles.fullWidthLine2} />
                <div
                  className={styles.rowTag2}
                  onClick={() => handleCreditChange("CARD")}
                >
                  <span className={styles.label2}>
                    <Checkbox
                      checked={creditCashValue === "CARD"}
                      disabled={selectionCreditLocked}
                      onChange={() => handleCreditChange("CARD")}
                    >
                      {" "}
                      CARD
                    </Checkbox>
                    <CreditCardIcon
                      style={{ fontSize: "15px", color: "red" }}
                    />
                  </span>
                  {/* <span className={styles.separator2}><CreditCardIcon  style={{fontSize:"30px", color:"red"}}/></span> */}
                  <span
                    className={styles.value2}
                    onClick={() => handleCreditChange("CARD")}
                  >
                    <Input
                      placeholder="Enter Card Amount"
                      style={{
                        width: "120px",
                        height: 32,
                        fontSize: "16px",
                        fontWeight: "bold",
                        textAlign: "right",
                      }}
                      value={creditCardAmt}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        if (value.length <= 10) {
                          setCreditCardAmt(value);
                          setCreditUpiAmt(0);
                          setCreditOnlineAmt(0);
                          setCreditCashAmt(0);
                        }
                      }}
                    />
                  </span>
                </div>
                <hr className={styles.fullWidthLine2} />
                <div
                  className={styles.rowTag2}
                  onClick={() => handleCreditChange("UPI")}
                >
                  <span className={styles.label2}>
                    <Checkbox
                      checked={creditCashValue === "UPI"}
                      disabled={selectionCreditLocked}
                      onChange={() => handleCreditChange("UPI")}
                    >
                      {" "}
                      UPI
                    </Checkbox>
                    <DocumentScannerIcon
                      style={{ fontSize: "15px", color: "blue" }}
                    />
                  </span>
                  {/* <span className={styles.separator2}><DocumentScannerIcon  style={{fontSize:"30px", color:"blue"}}/></span> */}
                  <span
                    className={styles.value2}
                    onClick={() => handleCreditChange("UPI")}
                  >
                    <Input
                      placeholder="Enter UPI Amount"
                      style={{
                        width: "120px",
                        height: 32,
                        fontSize: "16px",
                        fontWeight: "bold",
                        textAlign: "right",
                      }}
                      value={creditUpiAmt}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        if (value.length <= 10) {
                          setCreditUpiAmt(value);
                          setCreditOnlineAmt(0);
                          setCreditCardAmt(0);
                          setCreditCashAmt(0);
                        }
                      }}
                    />
                  </span>
                </div>
                <hr className={styles.fullWidthLine2} />
                <div
                  className={styles.rowTag2}
                  onClick={() => handleCreditChange("ONLINE")}
                >
                  <span className={styles.label2}>
                    <Checkbox
                      checked={creditCashValue === "ONLINE"}
                      disabled={selectionCreditLocked}
                      onChange={() => handleCreditChange("ONLINE")}
                    >
                      {" "}
                      ONLINE
                    </Checkbox>
                    <BookOnlineIcon
                      style={{ fontSize: "15px", color: "green" }}
                    />
                  </span>
                  {/* <span className={styles.separator2}><BookOnlineIcon  style={{fontSize:"30px", color:"green"}}/></span> */}
                  <span
                    className={styles.value2}
                    onClick={() => handleCreditChange("ONLINE")}
                  >
                    <Input
                      placeholder="Enter Online Amount"
                      style={{
                        width: "120px",
                        height: 32,
                        fontSize: "16px",
                        fontWeight: "bold",
                        textAlign: "right",
                      }}
                      value={creditOnlineAmt}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        if (value.length <= 10) {
                          setCreditOnlineAmt(value);
                          setCreditCardAmt(0);
                          setCreditUpiAmt(0);
                          setCreditCashAmt(0);
                        }
                      }}
                    />
                  </span>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default CashMethod;
